<template>
  <div>
    <section class="mt-50 mb-50 bg-ligh payments" id="payments">
      <div class="container">
        <div class="row d-flex">
          <div class="col-md-6 col-lg-6 d-flex order-md-last">
            <div class="img-about d-flex align-items-stretch">
              <div
                class="img d-flex align-self-stretch align-items-end"
                style="background-image: url(images/cash_flow2.jpg);"
              >
                <img src="../assets/cash_flow2.jpg" alt />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 pr-lg-5 py-3 py-lg-5">
            <div class="row justify-content-start py-3 py-lg-5">
              <div class="col-md-12">
                <h1 class="mb-4" style="font-size: 44px; text-transform: capitalize;">
                  <span class="blue_title">Your Customized Debt Relief Program</span>
                </h1>
                <div class="box_shadow_block">
                  <p>
                    As we all know,
                    <span class="span_red">Merchant Cash Advances</span> generally have much higher fees and interest rates than traditional bank loans. The potential danger of MCAs is that you may wind up in a vicious cycle of debt or end up in bankruptcy.
                  </p>
                  <p>
                    At
                    <span class="bda_span">Business Debt Adjusters</span> we negotiate with creditors to develop reduced payment plans that fit our clients. We can devise a debt settlement program tailored to meet your specific needs. We can free you from the weekly and daily drafts which are so inconvenient and eat up a lot of your precious time.
                  </p>
                  <p>
                    At
                    <span class="bda_span">Business Debt Adjusters</span> we apply the proven debt settlement strategies and our results are seen instantly. Take a look at some of our achievements below.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <RealResults />

    <section class="bg-light payments mt-50 mb-50" id="payments2">
      <div class="container">
        <div class="row d-flex">
          <div class="col-md-6 col-lg-6 d-flex">
            <div class="img-about d-flex align-items-stretch">
              <div class="img d-flex align-self-stretch align-items-end">
                <img src="../assets/creditdebt.jpg" alt />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 pr-lg-5 py-3 py-lg-5">
            <div class="row justify-content-start py-3 py-lg-5">
              <div class="col-md-12">
                <h2>
                  Our
                  <span class="bda_span">debt settlement program</span> is...
                </h2>
                <div class="box_shadow_block">
                  <ul>
                    <li>Well-structured</li>
                    <li>Convenient</li>
                    <li>Money-saving</li>
                  </ul>
                  <p>... and relieves the frustration of debt.</p>
                  <p>
                    So, don’t wait until your creditors are at your door!
                    Let us fix your financial problems!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RealResults from "@/components/realResults";
export default {
  components: {
    RealResults
  }
};
</script>
<style lang="scss" scoped>
.payments {
  img {
    width: 100%;
    align-self: stretch;
  }
}
@media (max-width: 767px) {
  .payments {
    img {
      width: 100%;
      align-self: unset;
      height: 200px;
    }
  }
}
</style>